export default __webpack_public_path__ + "static/media/Slider-4.479eacc8.jpg";